(() => {
  if (window.__FURMILY_CART_BUNDLE_ORDER__) return;
  window.__FURMILY_CART_BUNDLE_ORDER__ = true;

  let scheduled = false;
  let observer = null;

  const directItems = (list) =>
    Array.from(list?.children || []).filter((node) =>
      node instanceof HTMLElement && node.classList.contains('fm-cart__item')
    );

  const orderBundles = () => {
    scheduled = false;
    const list = document.querySelector('.fm-cart__list');
    if (!list) return false;

    const items = directItems(list);
    if (!items.length) return false;

    const fountains = items.filter((item) =>
      item.dataset.fmBundleKind === 'fountain' &&
      Boolean(item.dataset.fmBundleToken)
    );

    if (!fountains.length) return false;

    const used = new Set();
    const desired = [];

    const push = (item) => {
      if (!item || used.has(item)) return;
      used.add(item);
      desired.push(item);
    };

    for (const fountain of fountains) {
      const token = fountain.dataset.fmBundleToken;
      push(fountain);

      // Keep every bundle visually self-contained under its fountain.
      // Save More subscription first, then the free gifts.
      items
        .filter((item) =>
          !used.has(item) &&
          item.dataset.fmBundleToken === token &&
          item.dataset.fmBundleKind === 'subscription'
        )
        .forEach(push);

      items
        .filter((item) =>
          !used.has(item) &&
          item.dataset.fmBundleToken === token &&
          item.dataset.fmBundleKind === 'gift'
        )
        .forEach(push);

      items
        .filter((item) =>
          !used.has(item) &&
          item.dataset.fmBundleToken === token
        )
        .forEach(push);
    }

    // Preserve every unrelated/unmanaged cart line in its existing relative order.
    items.filter((item) => !used.has(item)).forEach(push);

    const alreadyOrdered =
      desired.length === items.length &&
      desired.every((item, index) => item === items[index]);

    if (alreadyOrdered) return false;

    const fragment = document.createDocumentFragment();
    desired.forEach((item) => fragment.appendChild(item));
    list.appendChild(fragment);
    return true;
  };

  const scheduleOrder = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(orderBundles);
  };

  const bindObserver = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (observer) observer.disconnect();
    observer = new MutationObserver(scheduleOrder);
    observer.observe(drawer, { childList: true, subtree: true });

    scheduleOrder();
  };

  window.FurMilyOrderCartBundles = orderBundles;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindObserver, { once: true });
  } else {
    bindObserver();
  }

  document.addEventListener('shopify:section:load', bindObserver);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      window.setTimeout(scheduleOrder, 0);
    });
  }
})();